import { render, staticRenderFns } from "./BurialsNewPage.vue?vue&type=template&id=70b2bab7"
import script from "./BurialsNewPage.vue?vue&type=script&lang=js"
export * from "./BurialsNewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports